<template>
  <v-flex class="list-main">
    <v-container style="margin-bottom: 0;">
      <h1 class="font-weight-bold mb-2 d-flex align-center">
        <v-icon
          v-if="type === 'default' || type === 'share' || type === 'public'"
          class="mr-3"
          large
        >
          mdi-database
        </v-icon>
        <span v-if="type === 'default'">
          Database
        </span>
        <span v-if="type === 'share'">
          Shared brains
        </span>
        <span v-if="type === 'public'">
          Public brains
        </span>
        <v-row v-if="type !== 'archives'">
          <v-col cols="11" :class="isDialog ? 'ml-4' : 'ml-4 text-right'">
            <span class="pl-1 subtitle-1 font-weight-bold darken-2">
              Arrangement
            </span>
            <v-btn
              text
              min-width="35px"
              :color="isGrid ? 'success' : 'gray'"
              class="px-0 justify-center mt-1"
              @click="isGrid = true"
            >
              <v-icon>mdi-grid</v-icon>
            </v-btn>
            <v-btn
              text
              min-width="35px"
              :color="isGrid ? 'gray' : 'success'"
              class="px-0 justify-center mt-1"
              @click="isGrid = false"
            >
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </h1>
      <h1
        v-if="type === 'archives'"
        class="font-weight-bold mb-12 mt-2 d-flex align-center"
      >
        <v-icon class="mr-3" large>mdi-delete</v-icon>
        <span>Archives</span>
      </h1>
      <h1 v-else><!-- Nothing --></h1>
      <v-btn
        v-if="type === 'default'"
        class="ml-5 mb-4"
        color="primary"
        dark
        @click.stop="setUploadDialog(true)"
      >
        + New
      </v-btn>
      <v-row dense>
        <v-col cols="3" class="font-weight-bold mt-6">
          <v-icon class="mr-3 ml-2">mdi-tag</v-icon>
          Search by tags...
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="conditions.cellLabels.selected"
            :items="conditions.cellLabels.items"
            chips
            label="Cell labels..."
            multiple
            item-text="Title"
          ></v-select>
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="conditions.experimentLabels.selected"
            :items="conditions.experimentLabels.items"
            chips
            label="Experiments..."
            multiple
            item-text="Title"
          ></v-select>
        </v-col>
      </v-row>
      <v-row
        dense
        v-if="
          $route.name === 'notebooks_new' ||
            $route.name === 'notebooks_detail' ||
            $route.name === 'studios_new' ||
            $route.name === 'studios_detail'
        "
      >
        <v-col cols="3" class="font-weight-bold mt-6">
          <v-icon class="mr-3 ml-2">mdi-database-search</v-icon>
          Target brains...
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="targetBrains.selected"
            :items="targetBrains.items"
            chips
            label="Brains..."
            item-text="Title"
            @change="switchBrain"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense v-if="isGrid">
        <v-col cols="9" />
        <v-col cols="2">
          <v-select
            v-model="sort.selectedType"
            :items="sort.items"
            dense
            label="Sort by..."
          ></v-select>
        </v-col>
        <v-col cols="1">
          <v-btn
            text
            v-if="sort.isAsc"
            class="px-0 justify-center mt-1"
            @click="sort.isAsc = false"
          >
            <v-icon>mdi-arrow-up</v-icon>
          </v-btn>
          <v-btn
            text
            v-if="!sort.isAsc"
            class="px-0 justify-center mt-1"
            @click="sort.isAsc = true"
          >
            <v-icon>mdi-arrow-down</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="isDialog">
        <v-col class="blue--text ml-3">
          <div v-if="type === 'dialog_single_selectable'">
            Click a brain to select.
          </div>
          Only brains whose status is "OK" are displayed.
        </v-col>
      </v-row>
      <transition name="accordion">
        <div>
          <!--Grid format from here.-->
          <v-row v-show="isGrid">
            <span v-if="!loaded" class="ml-8">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </span>
            <span
              v-if="loaded && displayBrains.length == 0"
              class="headline ml-5"
            >
              No data available
            </span>
            <v-col
              v-for="brain in displayBrains.slice(
                (page - 1) * itemsPerPage,
                page * itemsPerPage
              )"
              v-bind:key="brain.id"
              lg="3"
              md="4"
              sm="4"
              cols="6"
            >
              <v-card
                class="mx-auto"
                outlined
                @click="select(brain)"
                :ripple="isDialog"
                :style="{
                  cursor: isDialog ? 'pointer' : 'default',
                }"
              >
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-avatar
                      tile
                      size="150"
                      class="justify-center"
                      style="background-color: rgb(0, 0, 0);"
                    >
                      <v-img
                        v-if="brain.thumbnail"
                        :src="brain.thumbnail"
                        width="130px"
                        height="130px"
                        contain
                      >
                        <template v-slot:placeholder>
                          <v-layout
                            fill-height
                            align-center
                            justify-center
                            ma-0
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-layout>
                        </template>
                      </v-img>
                    </v-list-item-avatar>
                    <v-list-item-title class="headline mb-1">
                      <v-btn
                        v-if="!isDialog"
                        text
                        color="blue"
                        @click="showDetailDialog(brain)"
                        :loading="brain.loading"
                        class="text-none title-text"
                        style="padding: 0px; justify-content: left;"
                      >
                        <v-icon class="mr-3">mdi-file-outline</v-icon>
                        {{ trimText(brain.title.value, 15) }}
                      </v-btn>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      created at: {{ brain.created_at }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-card-actions style="height:30px;">
                  <template v-if="type === 'dialog_multiple_selectable'">
                    <v-spacer></v-spacer>
                    <v-icon v-if="brain.selected" class="mr-1" color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    <v-icon v-else class="mr-1">
                      mdi-checkbox-blank-outline
                    </v-icon>
                  </template>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>

          <!--List format from here.-->
          <v-row v-show="!isGrid">
            <v-responsive>
              <v-col>
                <v-data-table
                  :headers="headers"
                  :items="loaded ? displayBrains : []"
                  :items-per-page="itemsPerPage"
                  class="elevation-1 ml-3"
                  :mobile-breakpoint="MOBILE_BREAK_POINT"
                  :loading="!loaded"
                  @click:row="select"
                  :footer-props="{
                    'items-per-page-options': [25, 50, 100],
                    showFirstLastPage: true,
                  }"
                >
                  <template v-slot:item.title.value="{item}">
                    <template
                      v-if="
                        type === 'default' ||
                          type === 'share' ||
                          type === 'public'
                      "
                    >
                      <v-btn
                        text
                        color="blue"
                        @click.stop="showDetailDialog(item)"
                        class="text-none title-text"
                        :loading="item.loading"
                        style="padding: 0px;"
                      >
                        <v-icon class="mr-3">mdi-file-outline</v-icon>
                        {{ trimText(item.title.value, 15) }}
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-icon class="mr-3">mdi-file-outline</v-icon>
                      {{ trimText(item.title.value, 15) }}
                    </template>
                  </template>
                  <template v-slot:item.cellLabels.value="{item}">
                    <template v-for="(val, index) in item.cellLabels.value">
                      <v-chip
                        :key="index"
                        :color="'#' + val.Color"
                        :dark="isTextColorDark('#' + item.Color)"
                        class="ma-1"
                      >
                        {{ trimText(val.Title, 10) }}
                      </v-chip>
                    </template>
                  </template>
                  <template v-slot:item.experimentLabels.value="{item}">
                    <template
                      v-for="(val, index) in item.experimentLabels.value"
                    >
                      <v-chip
                        :key="index"
                        :color="'#' + val.Color"
                        :dark="isTextColorDark('#' + item.Color)"
                        class="ma-1"
                      >
                        {{ trimText(val.Title, 10) }}
                      </v-chip>
                    </template>
                  </template>
                  <template v-slot:item.statusText="{item}">
                    <div class="text-center">
                      <brain-status
                        :status="item.preprocessingStatus"
                      ></brain-status>
                    </div>
                  </template>
                  <template v-slot:item.shared="{item}">
                    <div class="text-center">
                      <v-icon v-if="item.shared">mdi-link-variant</v-icon>
                    </div>
                  </template>
                  <template v-slot:item.publicAccess="{item}">
                    <div class="text-center">
                      <v-icon v-if="item.publicAccess">mdi-earth</v-icon>
                    </div>
                  </template>
                  <template v-slot:item.owner="{item}">
                    <v-btn
                      text
                      color="blue"
                      class="text-none title-text"
                      style="padding: 0px; ustify-content: left;"
                      @click.stop="showProfileDialog(item.owner)"
                      :loading="item.owner.loading"
                    >
                      <v-icon class="mr-3">mdi-account</v-icon>
                      {{ trimText(item.owner.id, 8) }}
                    </v-btn>
                  </template>
                  <template
                    v-if="type !== 'dialog_multiple_selectable'"
                    v-slot:item.action="{item}"
                    style="padding: 0px;"
                  >
                    <v-btn
                      v-if="type === 'archives'"
                      text
                      color="blue"
                      @click.stop="restore(item)"
                      class="text-none"
                      :loading="item.loading"
                      style="padding: 0px;"
                    >
                      Move to
                      <br />
                      database
                    </v-btn>
                  </template>
                  <template v-else v-slot:item.action="{item}">
                    <v-icon v-if="item.selected" color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-responsive>
          </v-row>
          <div class="text-center pt-2 mb-10">
            <v-pagination
              v-if="isGrid"
              v-model="page"
              :length="pageCount"
            ></v-pagination>
            <template v-if="isDialog">
              <v-btn
                v-if="type === 'dialog_multiple_selectable'"
                v-show="displayBrains.length > 0"
                class="mt-5"
                color="primary"
                dark
                @click.stop="setSelectedBrains()"
              >
                Select
              </v-btn>
              <v-row>
                <v-col class="text-right">
                  <v-btn
                    color="error"
                    @click="$emit('setSelectBrainDialog', false)"
                  >
                    Cancel
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </div>
        </div>
      </transition>

      <!-- detail dialog -->
      <template v-if="detailDialog">
        <detail-dialog
          :detail-dialog="detailDialog"
          :current-brain="currentBrain"
          :brains="brains"
          :conditions="conditions"
          @setDetailDialog="setDetailDialog"
          @initBrains="initBrains"
        ></detail-dialog>
      </template>

      <!-- upload dialog -->
      <template v-show="uploadDialog">
        <upload-dialog
          :upload-dialog="uploadDialog"
          :conditions="conditions"
          @setUploadDialog="setUploadDialog"
          @initBrains="initBrains"
        ></upload-dialog>
      </template>

      <!-- profile dialog -->
      <template v-show="profileDialog">
        <profile-dialog
          :profile-dialog="profileDialog"
          :profile="currentProfile"
          @setProfileDialog="setProfileDialog"
        ></profile-dialog>
      </template>
    </v-container>
  </v-flex>
</template>

<script>
import {mapState, mapMutations} from 'vuex'
import Vue from 'vue'

import BrainStatus from '@/components/brain/BrainStatus.vue'
import DetailDialog from '@/components/brain/DetailDialog.vue'
import UploadDialog from '@/components/brain/UploadDialog.vue'
import ProfileDialog from '@/components/account/ProfileDialog.vue'

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer, {
  defaultOptions: {
    title: false,
    toolbar: false,
    zoomable: false,
    movable: false,
  },
})

export default {
  components: {
    BrainStatus,
    DetailDialog,
    UploadDialog,
    ProfileDialog,
  },
  props: {
    type: {
      type: String,
      validator(val) {
        return [
          'default',
          'dialog_multiple_selectable',
          'dialog_single_selectable',
          'archives',
          'share',
          'public',
        ].includes(val)
      },
      default: 'default',
    },
    selectedBrains: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    uploadDialog: false,
    detailDialog: false,
    profileDialog: false,
    isGrid: false,
    brains: [],
    loaded: false,
    initing: false,
    conditions: {
      mouseLines: {
        category: 'strain',
        items: null,
      },
      cellLabels: {
        category: 'marker',
        items: null,
        selected: [],
      },
      experimentLabels: {
        category: 'experiment',
        items: null,
        selected: [],
      },
    },
    targetBrains: {
      selected: 'My database',
      items: ['My database', 'Shared'],
    },
    currentBrain: null,
    currentProfile: null,
    headers: [
      {text: 'Title', value: 'title.value', width: '300px'},
      {
        text: 'Created at',
        value: 'created_at',
        width: '120px',
      },
      {
        text: 'Cell labels',
        value: 'cellLabels.value',
        width: '120px',
      },
      {
        text: 'Experiments',
        value: 'experimentLabels.value',
        width: '120px',
      },
      {text: 'Status', value: 'statusText', width: '100px'},
      {text: 'Shared?', value: 'shared', width: '100px'},
      {text: 'Public?', value: 'publicAccess', width: '100px'},
      {text: 'Owner', value: 'owner', width: '200px'},
      {text: '', value: 'action', sortable: false, width: '20px'},
    ],
    page: 1,
    pageCount: 0,
    itemsPerPage: 25,
    sort: {
      isAsc: false,
      items: ['Title', 'Data Created'],
      selectedType: 'Data Created',
      condition: '',
    },
  }),
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    displayBrains: function() {
      let displayBrains = []
      // Display all.
      if (
        this.conditions.experimentLabels.selected.length == 0 &&
        this.conditions.cellLabels.selected.length == 0
      ) {
        displayBrains = this.brains.concat()
      }
      // Search by and-condition if both of the conditions are specified.
      if (
        this.conditions.experimentLabels.selected.length > 0 &&
        this.conditions.cellLabels.selected.length > 0
      ) {
        this.brains.forEach((brain) => {
          let checkExperimentLabels
          let checkCellLabels = false

          for (const item of brain.experimentLabels.value) {
            if (
              this.conditions.experimentLabels.selected.includes(item.Title)
            ) {
              checkExperimentLabels = true
              break
            }
          }
          for (const item of brain.cellLabels.value) {
            if (this.conditions.cellLabels.selected.includes(item.Title)) {
              checkCellLabels = true
              break
            }
          }
          if (checkExperimentLabels && checkCellLabels) {
            displayBrains.push(brain)
          }
        })
      } else {
        this.brains.forEach((brain) => {
          //  Search by or-condition if one of the conditions is specified.
          for (const item of brain.experimentLabels.value) {
            if (
              this.conditions.experimentLabels.selected.includes(item.Title)
            ) {
              displayBrains.push(brain)
              break
            }
          }
          for (const item of brain.cellLabels.value) {
            if (this.conditions.cellLabels.selected.includes(item.Title)) {
              displayBrains.push(brain)
              break
            }
          }
        })
      }
      // Sort
      if (this.sort.selectedType === 'Title') {
        return this.sortByTitle(displayBrains, this.sort.isAsc)
      } else if (this.sort.selectedType === 'Data Created') {
        return this.sortByCreatedAt(displayBrains, this.sort.isAsc)
      } else {
        // Do nothing.
      }
      return displayBrains
    },
    isDialog: function() {
      return (
        this.type === 'dialog_multiple_selectable' ||
        this.type === 'dialog_single_selectable'
      )
    },
  },
  watch: {
    sort: {
      handler: function(val, oldVal) {
        this.page = 1
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations({
      setContent: 'pages/setContent',
    }),
    select(brain) {
      if (
        this.type !== 'dialog_multiple_selectable' &&
        this.type !== 'dialog_single_selectable'
      ) {
        // Do nothing.
        return
      }
      if (this.type === 'dialog_single_selectable') {
        this.$emit('setSelectedBrains', [brain])
        this.$emit('setSelectBrainDialog', false)
      } else {
        brain.selected = !brain.selected
      }
    },
    setSelectedBrains() {
      const selectedBrains = []
      for (const brain of this.displayBrains) {
        if (brain.selected) {
          selectedBrains.push(brain)
        }
      }
      this.$emit('setSelectedBrains', selectedBrains)
      this.$emit('setSelectBrainDialog', false)
    },
    async showDetailDialog(brain) {
      // get brain detail info
      if (!brain.loaded) {
        brain.loading = true
        let detail
        try {
          detail = await this.getBrainById(brain.id)
        } catch (error) {
          alert(this.getCommonErrorMessage(error))
          return
        }
        for (const period in brain.age.periods) {
          if (detail.Age % brain.age.periods[period] == 0) {
            brain.age.period = period
            brain.age.dispPeriod = period
            brain.age.value = detail.Age / brain.age.periods[period]
            brain.age.dispValue = detail.Age / brain.age.periods[period]
            break
          }
        }
        if (!brain.thumbnail) {
          const thumbnail = await this.getBrainThumbnailById(brain.id)
          if (!thumbnail) {
            // Do nothing.
          } else {
            brain.thumbnail = thumbnail
          }
        }
        if (detail.Strain) {
          const strain = await this.getMyTagsById('strain', detail.Strain)
          if (!strain) {
            brain.strain.value = null
            brain.strain.dispValue = null
          } else {
            brain.strain.value = strain
            brain.strain.dispValue = brain.strain.value
          }
        }
        if (!brain.owner.loaded) {
          brain.owner.info = await this.getAccountById(brain.owner.id)
          brain.owner.loaded = true
        }
        brain.notes.value = detail.Notes
        brain.notes.dispValue = detail.Notes
        brain.loading = false
        brain.loaded = true
      }
      this.currentBrain = brain
      this.detailDialog = true
    },
    async showProfileDialog(owner) {
      if (!owner.loaded) {
        owner.loading = true
        owner.info = await this.getAccountById(owner.id)
        owner.loading = false
        owner.loaded = true
      }
      if (owner.info) {
        this.currentProfile = owner.info
        this.profileDialog = true
      }
    },
    async restore(brain) {
      brain.loading = true
      const result = await this.restoreBrain(brain.id)
      if (!result) {
        // Do nothing and continue the process.
      }
      this.initBrains()
    },
    setUploadDialog(isShow) {
      this.uploadDialog = isShow
    },
    setDetailDialog(isShow) {
      this.detailDialog = isShow
    },
    setProfileDialog(isShow) {
      this.profileDialog = isShow
    },
    async initBrains(full = true) {
      while (true) {
        if (!this.initing) {
          break
        }
        await new Promise((resolve) => setTimeout(resolve, 2000))
      }
      if (full) {
        // Reset all conditions including dialog windows.
        Object.assign(this.$data, this.$options.data())
      } else {
        this.loaded = false
        this.brains = []
      }
      this.initing = true
      this.$_processHeaderByType()
      // Set conditions
      for (const condition of Object.values(this.conditions)) {
        if (condition.items) {
          continue
        }
        const list = await this.getMyTags(condition.category)
        if (!list) {
          break
        }
        condition.items = list.Items
      }
      const items = await this.getBrains(this.type)
      if (!items) {
        this.initing = false
        return
      }
      // Set labels
      await this.setLabelsForBrain(items)
      // Set brains
      for (const item of items) {
        if (this.isDialog && item.PreprocessingStatus !== 'complete') {
          continue
        }
        this.brains.push(this.convertBrainObjectForDisplay(item))
      }
      // Judge selected or not.
      for (const brain of this.brains) {
        for (const selectedBrain of this.selectedBrains) {
          if (brain.id === selectedBrain.id) {
            brain.selected = true
          }
        }
      }
      // Redirect from dashboard
      const detailBrainId = this.$route.params.brain_id || null
      if (detailBrainId) {
        for (const brain of this.brains) {
          if (brain.id === detailBrainId) {
            await this.showDetailDialog(brain)
            break
          }
        }
        // If brainId is not found
        const archivedBrains = await this.getBrains('archives')
        for (const archivedBrain of archivedBrains) {
          if (archivedBrain.ItemId === detailBrainId) {
            alert('This brain was archived.')
            break
          }
        }
        // If brainId is not found and also not in archives, do nothing.
      }
      this.loaded = true
      this.initing = false
      if (this.type === 'archives') {
        return
      }
      // Set thumbnail.
      for (const brain of this.brains) {
        if (!brain.thumbnail) {
          brain.thumbnail = await this.getBrainThumbnailById(brain.id)
        }
      }
    },
    async switchBrain() {
      while (true) {
        if (!this.initing) {
          break
        }
        await new Promise((resolve) => setTimeout(resolve, 2000))
      }
      this.loaded = false
      this.brains = []
      this.initing = true
      this.$_processHeaderByType()

      const shared = this.targetBrains.selected === 'Shared'
      const items = await this.getBrains('default', shared)
      if (!items) {
        this.initing = false
        return
      }
      // Set labels
      await this.setLabelsForBrain(items)
      // Set brains
      for (const item of items) {
        if (this.isDialog && item.PreprocessingStatus !== 'complete') {
          continue
        }
        this.brains.push(this.convertBrainObjectForDisplay(item))
      }
      // Judge selected or not.
      for (const brain of this.brains) {
        for (const selectedBrain of this.selectedBrains) {
          if (brain.id === selectedBrain.id) {
            brain.selected = true
          }
        }
      }
      // Redirect from dashboard
      const detailBrainId = this.$route.params.brain_id || null
      if (detailBrainId) {
        for (const brain of this.brains) {
          if (brain.id === detailBrainId) {
            await this.showDetailDialog(brain)
            break
          }
        }
        // If brainId is not found
        const archivedBrains = await this.getBrains('archives')
        for (const archivedBrain of archivedBrains) {
          if (archivedBrain.ItemId === detailBrainId) {
            alert('This brain was archived.')
            break
          }
        }
        // If brainId is not found and also not in archives, do nothing.
      }
      this.loaded = true
      this.initing = false
    },
    $_processHeaderByType() {
      switch (this.type) {
        case 'default':
          this.headers = this.headers.filter(
            (header) => header.value !== 'owner' && header.value !== 'action'
          )
          break
        case 'dialog_single_selectable':
          this.headers = this.headers.filter(
            (header) =>
              header.value !== 'statusText' &&
              header.value !== 'owner' &&
              header.value !== 'action'
          )
          this.headers = this.headers.map((header) => {
            delete header.width
            return header
          })
          break
        case 'dialog_multiple_selectable':
          this.headers = this.headers.filter(
            (header) =>
              header.value !== 'statusText' && header.value !== 'owner'
          )
          this.headers = this.headers.map((header) => {
            delete header.width
            return header
          })
          break
        case 'share':
        case 'public':
          this.headers = this.headers.filter(
            (header) =>
              header.value !== 'shared' &&
              header.value !== 'publicAccess' &&
              header.value !== 'status' &&
              header.value !== 'action'
          )
          break
        case 'archives':
          this.headers = this.headers.filter(
            (header) => header.value !== 'owner'
          )
          break
        default:
      }
    },
  },
  mounted() {
    this.initBrains()
  },
}
</script>

<style scoped>
.list-main >>> .v-data-table-header {
  background-color: WhiteSmoke;
}
.list-main >>> .v-data-table-header th {
  border-bottom: gray 1px solid !important;
}
.list-main >>> .v-data-table-header-mobile {
  display: none;
}
.list-main >>> .title-text > .v-btn__content {
  justify-content: left;
}
</style>
